// Sagas are what field all the async requests in redux.  They make it easier
// to deal with this data, and also make it easier to test async calls from the ui
// You can read more about them here: https://github.com/redux-saga/redux-saga

import { put, call, all, takeEvery, takeLatest } from "redux-saga/effects";
import { checkPayoff, validateLoanPayment, verifyAppraisalCharge } from "../utils/requests";
import { errorMessages } from '../utils/content'

export function* verifyPayment({ paymentDetails, paymentType }) {
  let endpoint = paymentType === 'appraisal' ? verifyAppraisalCharge : validateLoanPayment;
  let checkPayoffObject = {
    Amount: parseFloat(paymentDetails.Amount || paymentDetails.amount),
    AchOrDebit: "debit",
    AchRoutingNumber: "",
    AchAccountNumber: "",
    AchIsChecking: false,
    personId: paymentDetails.personId,
    isPrincipalOnly: paymentDetails.isPrincipalOnlyDebit,
  };


  try {
    yield put({
      type: "CLEAR_PAYOFF_CHECK",
    })
    yield put({
      type: "HIDE_NOTIFICATION"
    });
    yield put({
      type: "SHOW_MODAL",
      modalType: "loading",
      message: "Loading..."
    });

    if (paymentType != 'appraisal') {
      const payoffCheck = yield call(checkPayoff, checkPayoffObject)

      // Check and set message before we possibly terminate the saga due to principal payment type switch
      if (payoffCheck.Message != "") {
        yield put({
          type: "SHOW_NOTIFICATION",
          notificationType: "error",
          message: payoffCheck.Message,
        });
      }

      if(paymentDetails.isPrincipalOnlyDebit && payoffCheck.PaymentTypeChangedToPayoff) {
        yield put({
          type: "SET_PRINCIPAL_PAYOFF_SWITCH",
          switch: true,
        })
        yield put({
          type: "HIDE_MODAL",
          modalType: "loading"
        });
        return;
      }

      yield put({
        type: "SET_PAYOFF_CHECK",
        payload: payoffCheck
      })

      if (payoffCheck.Message != "") {
        // End saga if payment is not allowed for this submission
        yield put({
          type: "HIDE_MODAL",
          modalType: "loading"
        });
        return;
      }
    }

    const data = yield call(endpoint, paymentDetails);
    yield put({
      type: "VERIFY_PAYMENT_COMPLETE",
      payload: data
    });
    yield put({
      type: "HIDE_MODAL",
      modalType: "loading"
    });
    // If there is an error, show the notification at the top
    if (data.PaymentError != "") {
      yield put({
        type: "SHOW_NOTIFICATION",
        notificationType: "error",
        message: data.PaymentError
      });
    }
  } catch (error) {
    yield put({
      type: "SHOW_NOTIFICATION",
      notificationType: "error",
      message: errorMessages.verifyingPaymentDetailsFailed
    });
    yield put({
      type: "HIDE_MODAL",
      modalType: "loading"
    });
  }
}

// Watch for loan request and execute action to set loan state
export function* watchPaymentVerificationRequest() {
  yield takeEvery("VERIFY_PAYMENT", verifyPayment);
}



// WEBPACK FOOTER //
// ./src/sagas/verifyPayment.sagas.js